import Api from './../service/Api';

export default {
  findCfc: () => Api.get('cfcs/'+Api.defaults.headers.codeCfc),
  getQuantidadeBiometria: () => Api.get('cfc/getQuantidadeBiometria'),
  findDsCfc: (codigo) => Api.get('ds_cfc/' + codigo),
};
